"use strict";
var lib_core = require("lib-core");

var TrayAssetUpdateTabContentModel = function (rootStateMachine) {
    var self = this;
    lib_core.Model.call(this);

    this.rootStateMachine = rootStateMachine;

    this.loading = false;
    this.all_loaded = false;
    this.request_id = 0;

    this.visible = this.value("visible", false, true, false);

    this.name                 = this.value("name", "", false, true);
    this.title                = this.value("title", "", false, true);
    this.type                 = this.value("type", "", false, true);
    this.template             = this.value("template", "", false, true);
    this.alternative_template = this.value("alternative_template", false, false, true);
    this.query                = this.value("query", "", false, true);
    this.default_query_fields = this.value("default_query_fields", "", false, true);
    this.data                 = this.value("data", null, false, true);
    this.numberOfResults      = this.value("numberOfResults", 0, false, true);
    this.sorting              = this.value("sorting", "updated_at", false, true);
    this.sorting_direction    = this.value("sorting_direction", "desc", false, true);
    this.collection           = null;

    this.query.onChange("query_change", function () {self.reload();});
    this.sorting.onChange("sorting_change", function () {self.reload();});
};

lib_core.inherit(TrayAssetUpdateTabContentModel, lib_core.Model);
TrayAssetUpdateTabContentModel.$class = "TrayTabContentModel";

module.exports = TrayAssetUpdateTabContentModel;

TrayAssetUpdateTabContentModel.prototype.reload = function() {
    this.loadData(0);
};

TrayAssetUpdateTabContentModel.prototype.getNext = function() {
};

TrayAssetUpdateTabContentModel.prototype.loadData = function() {
    var self = this;

    var promises = [];
    self.collection.forEach(function(bla, instance) {
        var header = instance.ancestor().root.header;
        promises.push(self.root.contentServerClient.getResource(header["assetType"], header["assetId"]));
    });

    Promise.all(promises).then(function(data) {
        self.data(data);
    });
};
